import Config from "../Config";
import Moment from "moment";
import { globalState } from "../data/global/globalState";

//This bloc is not used in this project
class SessionBloc {
  static redirectToLogin() {
    sessionStorage.removeItem("dataUser");
    const userType = sessionStorage.getItem("clientType");
    const clientUUID = sessionStorage.getItem("uuid");

    // Regular expression to validate UUID (version 4)
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    // Function to construct safe URLs
    const createSafeUrl = (base, ...params) => {
      const url = new URL(base, window.location.origin);
      params.forEach(
        (param) => (url.pathname += `/${encodeURIComponent(param)}`)
      );
      return url.toString();
    };

    if (userType) {
      console.log("Logged out, redirect to Client login");

      // Validate clientUUID before using it
      if (clientUUID && uuidRegex.test(clientUUID)) {
        const safeUrl = createSafeUrl(
          Config.context,
          "client",
          Config.routes.generic.authentication,
          clientUUID
        );
        window.location.href = safeUrl;
      } else {
        console.error("Invalid UUID, redirect to a safe page");
        const safeUrl = createSafeUrl(Config.context, "error");
        window.location.href = safeUrl;
      }
    } else {
      console.log("Logged out, redirect to Agent login");
      const safeUrl = createSafeUrl(Config.context, "login");
      window.location.href = safeUrl;
    }
  }

  static backToDashboard() {
    const safeUrl = new URL(
      `${Config.context}/${Config.routes.generic.dashboard}`,
      window.location.origin
    ).toString();
    window.location.href = safeUrl;
  }

  static setGlobalUserConfig(config) {
    globalState.userConfig = config;
  }
  static setGlobalFilterBy(filterBy) {
    globalState.filterBy = filterBy;
  }
  static setGlobalSearchBy(searchBy) {
    globalState.searchBy = searchBy;
  }
  static setGlobalUserInfo(userInfo) {
    // console.log("Setting user global info to " + JSON.stringify(userInfo));
    globalState.userInfo = userInfo;
    // console.log("Getting user global info = " + JSON.stringify(globalState.userInfo));
  }

  static privateEncode(auth) {
    return auth
      .toLocaleLowerCase()
      .replaceAll("a", "1")
      .replaceAll("b", "2")
      .replaceAll("c", "3")
      .replaceAll("d", "4")
      .replaceAll("e", "5")
      .replaceAll("6", "z")
      .replaceAll("7", "x")
      .replaceAll("8", "c")
      .replaceAll("9", "v");
  }

  //Generate UUID
  static getRequestUUID() {
    var d = new Date().getTime(); //Timestamp
    var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16; //random number between 0 and 16
      if (d > 0) {
        //Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        //Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  //Get current session in cache for the particular product
  static getCurrentSessionId(productCode) {
    let sessionId = localStorage.getItem(Config.cache.sessionID + productCode);
    if (!sessionId || sessionId === null || sessionId === "") {
      sessionId = this.getRequestUUID();
      localStorage.setItem(Config.cache.sessionID + productCode, sessionId);
    }
    return sessionId;
  }

  //Set the new session ID to cache for the particular product
  static setCurrentSessionId(productCode, sessionId) {
    localStorage.setItem(Config.cache.sessionID + productCode, sessionId);
  }
}

export default SessionBloc;
